import type * as React from "react"
import { useIntersection } from "react-use"

export function useOnScreen(ref: React.RefObject<HTMLElement | null>, rootMargin = "0px") {
  const observerEntry = useIntersection(ref as React.RefObject<HTMLElement>, {
    rootMargin,
  })
  return !!observerEntry?.isIntersecting
}
